import { NextResponse } from "next/server";
import axios from "axios";
import { REDIRECT_URL } from '@/Utils/Other/Constant';

export async function POST(req) {
    try {
        const { code } = await req.json();

        // const propsData = {
        //     code: code,
        //     client_id: process.env.GOOGLE_CLIENT_ID,
        //     redirect_uri: REDIRECT_URL,
        //     client_secret: process.env.GOOGLE_CLIENT_SECRET_ID,
        //     scope: 'https://www.googleapis.com/auth/youtube.readonly',
        //     grant_type: 'authorization_code',
        //     access_type: 'offline',
        // };

        // console.log("propsData", propsData);

        const response = await axios.post("https://oauth2.googleapis.com/token",
            new URLSearchParams({
                code: code,
                client_id: process.env.GOOGLE_CLIENT_ID,
                client_secret: process.env.GOOGLE_CLIENT_SECRET_ID,
                redirect_uri: REDIRECT_URL,
                grant_type: "authorization_code",
            }), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });

        console.log("response", response.data);

        let user_info = null;
        if (response.data.id_token) {
            const tokenInfoResponse = await axios.get(
                "https://oauth2.googleapis.com/tokeninfo",
                { params: { id_token: response.data.id_token } }
            );
            user_info = tokenInfoResponse.data;
        }

        return NextResponse.json({ data: { ...response.data, user_info } });
    } catch (error) {
        console.error("Error during getting youtube auth:", error.response ? error.response.data : error.message);
        return NextResponse.json(
            { error: "Youtube auth failed", details: error.response ? error.response.data : error.message },
            { status: 500 }
        );
    }
}